export const HabitationRequestStatusTypes = {
    ALL: {
        title: "همه",
        id: "ALL"
    },
    REJECTED: {
        title: "رد شده",
        id: "REJECTED"
    },
    ACCEPTED: {
        title: "پذیرفته شده",
        id: "ACCEPTED"
    },
    CANCELLED: {
        title: "لغو شده",
        id: "CANCELLED"
    },
    CANCELLED_FOR_ABSENT: {
        title: "غیبت",
        id: "CANCELLED_FOR_ABSENT"
    },
    REFERRED: {
        title: "مراجعه شده",
        id: "REFERRED"
    },
    IN_AWAITING_LIST: {
        title: "در صف انتظار",
        id: "IN_AWAITING_LIST"
    },
    POSTED: {
        title: "در حال بررسی",
        id: "POSTED"
    },
    SUBMITTED: {
        title: "ثبت شده",
        id: "SUBMITTED"
    },
    AWAITING_FOR_MANAGER_REVIEW: {
        title: "بررسی مدیر",
        id: "AWAITING_FOR_MANAGER_REVIEW"
    },
    AWAITING_FOR_DOCUMENT_UPLOAD: {
        title: "در انتظار مدارک",
        id: "AWAITING_FOR_DOCUMENT_UPLOAD"
    }
}


export const HabitationRequestStatusTypesList = [
    HabitationRequestStatusTypes.ALL,
    HabitationRequestStatusTypes.REJECTED,
    HabitationRequestStatusTypes.ACCEPTED,
    HabitationRequestStatusTypes.CANCELLED,
    HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT,
    HabitationRequestStatusTypes.REFERRED,
    HabitationRequestStatusTypes.IN_AWAITING_LIST,
    HabitationRequestStatusTypes.POSTED,
    HabitationRequestStatusTypes.AWAITING_FOR_DOCUMENT_UPLOAD
]

export const HabitationOrderTypes = {
    SEND_AT_DESC: {
        id: "SEND_AT_DESC",
        title: "جدیدترین ها"
    },
    SEND_AT_ASC: {
        id: "SEND_AT_ASC",
        title: "قدیمی ترین ها"
    },
}

export function getHabitationRequestStatus(status) {
    switch (status) {
        case HabitationRequestStatusTypes.REFERRED.id: {
            return HabitationRequestStatusTypes.REFERRED.title
        }
        case HabitationRequestStatusTypes.REJECTED.id: {
            return HabitationRequestStatusTypes.REJECTED.title
        }
        case HabitationRequestStatusTypes.POSTED.id: {
            return HabitationRequestStatusTypes.POSTED.title
        }
        case HabitationRequestStatusTypes.CANCELLED.id: {
            return HabitationRequestStatusTypes.CANCELLED.title
        }
        case HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id: {
            return HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.title
        }
        case HabitationRequestStatusTypes.IN_AWAITING_LIST.id: {
            return HabitationRequestStatusTypes.IN_AWAITING_LIST.title
        }
        case HabitationRequestStatusTypes.ACCEPTED.id: {
            return HabitationRequestStatusTypes.ACCEPTED.title
        }
        case HabitationRequestStatusTypes.SUBMITTED.id: {
            return HabitationRequestStatusTypes.SUBMITTED.title
        }
        case HabitationRequestStatusTypes.AWAITING_FOR_MANAGER_REVIEW.id: {
            return HabitationRequestStatusTypes.AWAITING_FOR_MANAGER_REVIEW.title
        }
        case HabitationRequestStatusTypes.AWAITING_FOR_DOCUMENT_UPLOAD.id: {
            return HabitationRequestStatusTypes.AWAITING_FOR_DOCUMENT_UPLOAD.title
        }
    }
}


export const HabitationOrderTypesList = [
    HabitationOrderTypes.SEND_AT_ASC,
    HabitationOrderTypes.SEND_AT_DESC,
]